/* eslint-disable camelcase*/
import root from "./root";
import clothing from "./clothing";
import cups from "./cups";
import men_tshirts from "./men-tshirts";
import sweatshirts from "./sweatshirts";
import kids_items from "./kids_items";
import office_supplies from "./office_supplies";
import home_supplies from "./home_supplies";
import accessories from "./accessories";
import sport_clothing from "./sport_clothing";
import phone_cases from "./phone_cases";
import edible from "./edible";
import interior from "./interior";

export default {
  root,
  clothing,
  cups,
  men_tshirts,
  sweatshirts,
  kids_items,
  office_supplies,
  home_supplies,
  accessories,
  sport_clothing,
  phone_cases,
  edible,
  interior
};
